import { StrictMode, createRoot } from "@wordpress/element";
import Faqs from "./Faqs";

// Mount the component to the 'root' div
const root = document.getElementById('content-faqs');

if (root) {
  createRoot(root).render(
    <StrictMode>
      <Faqs />
    </StrictMode>
  );
}
